import { ChangeDetectionStrategy, Component, EventEmitter, Inject, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ITerminalTemplate, TerminalTemplateAdministrationService } from '@shared/services/terminaltemplateAdministration.service';

@Component({
	selector: 'app-delete-terminaltemplate',
	templateUrl: './delete-terminaltemplate.component.html',
	styleUrls: ['./delete-terminaltemplate.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class DeleteTerminalTemplateComponent {
	@Output() deleted: EventEmitter<any> = new EventEmitter();
	httpError: string = '';
	loading: boolean | null;

	constructor(
		@Inject(MAT_DIALOG_DATA) public terminalTemplate: ITerminalTemplate,
		public dialogRef: MatDialogRef<DeleteTerminalTemplateComponent>,
		private terminalTemplateService: TerminalTemplateAdministrationService,
	) {}

	onCancel = () => this.dialogRef.close();

	async onDelete() {
		if (this.loading) return;
		this.loading = true;
		this.httpError = '';
		this.terminalTemplateService.deleteTerminalTemplateById(this.terminalTemplate.id).subscribe({
			next: () => {
				this.deleted.emit();
				this.dialogRef.close();
			},
			error: (errorResponse) => {
				this.httpError = `${errorResponse.status}`;
				this.loading = false;
			},
		});
	}
}
